export enum IRole {
    Anon = "anonymous",
    User = "user",
    Admin = "admin"
}

export interface ISession {
    exp: number | null;
    role: IRole | null;
}
